<template>
  <ol class="c-steps">
    <li v-for="status in statuses" :key="status.name" class="c-steps__item" v-bind:class="{ 'is-finished': !!order[status.name] }">
      <div class="c-steps__media">
        <span class="c-steps__count"><i :class="status.icon"/></span>
      </div>
      <div class="c-steps__content">
        <div class="c-steps__title">{{ $t(status.name).label }}</div>
      </div>
    </li>
  </ol>
</template>

<script>
  export default {
    data: () => ({
      statuses: [
        { name: 'invoiced', icon: 'icon-clipboard2' },
        { name: 'shipped', icon: 'icon-truck' },
        { name: 'delivered', icon: 'icon-home2' }
      ]
    }),
    props: {
      order: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="sass" scoped>
  ol
    margin: 30px 30px 40px

  .c-steps__item.is-finished .c-steps__count
    color: #ffffff
    background-color: green
    border-color: green

  .c-steps__item.is-finished .c-steps__title:after
    background-color: green
</style>




// WEBPACK FOOTER //
// Stepper.vue?2ea94f12